import React,{useState,useEffect,Fragment} from 'react'
import ButtonRow from './ButtonRow'

const Comment = ({comment,onSave,onDelete,canEdit}) => {
    const [buttonsVisible,setButtonsVisible] = useState(false)
    const [editMode,setEditMode] = useState(null)
    const [text,setText] = useState(typeof comment.content === 'object' ? comment.content.rendered.replace(/(<([^>]+)>)/ig,"") : comment.content)
    
    useEffect( () => {
        setEditMode(false)
        setButtonsVisible(false)
    }, [comment,setEditMode,setButtonsVisible])

    const buttons = canEdit || comment.id === 0 ? 
        <Fragment>
            <ButtonRow 
                visible={buttonsVisible && comment.id !== 0}
                buttons={[
                    {
                        label: 'Delete',
                        action: () => {
                            setButtonsVisible(!buttonsVisible)
                            if(onDelete) onDelete(comment.id);
                        },
                        style: 'danger'
                    },
                    {   
                        label: 'Edit',
                        action: () => {setEditMode(true); setButtonsVisible(!buttonsVisible)},
                        style: 'primary'
                    },
                    {   
                        label: 'Cancel',
                        action: () => setButtonsVisible(!buttonsVisible),
                        style: 'secondary'
                    }
                ]}
            />
            <ButtonRow 
                visible={editMode || comment.id === 0}
                buttons={[
                    {
                        style: 'spacer'
                    },
                    {   
                        label: 'Cancel',
                        action: () => {
                            setButtonsVisible(!buttonsVisible)
                            if(onDelete) onDelete(comment.id);
                        },
                        style: 'secondary'
                    },
                    {   
                        label: 'Save',
                        action: () => {
                            const editedComment = comment.id !== 0 ? {content: text} : {author: comment.author, post: comment.post, content: text}
                            if(onSave) onSave(comment.id, editedComment );
                        } ,
                        style: 'success'
                    }
                ]}
            />
        </Fragment> : <Fragment/>
        
        
    let commentColor = 'black';

    if(comment.justSaved) commentColor = 'darkgreen';
    if(comment.error) commentColor = 'darkred';

    const errorRow = comment.error ? <li className="comment-error">{comment.error.message}</li> : ''

    return(
        <Fragment>
            <li className='comment-row' key={comment.id} onClick={ editMode || !canEdit ? () => {} : () => setButtonsVisible(!buttonsVisible)}>
                <div className="comment-author"><span className="badge badge-dark">{comment.author_name}</span></div>
                <div className="comment-date">{comment.formatted_date}</div>
                <div className="comment-content" style={{color: commentColor}}>{
                    editMode || comment.id === 0 ? <textarea onChange={ e => setText(e.target.value)}>{text}</textarea> : text}
                </div>
            </li>

            {buttons}
            {errorRow}
        </Fragment>
        
    )
}



export default Comment;